import React from 'react';

import i18n from 'i18next';

import useTitleWithAccountName from '../hooks/useTitleWithAccountName';
import useMyVideos from '../hooks/useMyVideos';

import MyVideos from '../components/myVideos';

export default () => {
  const {
    screenSize,
    handleBrowse,
  } = useMyVideos();

  useTitleWithAccountName(i18n.t('my-videos'));

  return (
    <MyVideos
      screenSize={screenSize}
      handleBrowse={handleBrowse}
    />
  );
};
